import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '66vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Adsmitra = () => {

    const [adsData, setAdsData] = useState([]);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleOpenEdit = (val) => {
        setValToEdit(val);
        setOpenEdit(true);
    };
    const handleCloseEdit = () => {
        setValToEdit([]);
        setOpenEdit(false);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [openDelDialog, setOpenDelDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [valToEdit, setValToEdit] = useState([]);
    const [id, setId] = useState(null);

    const handleDeleteDialog = (id) => {
        setId(id);
        setOpenDelDialog(true);
    };
  
    const handleCloseDeleteDialog = () => {
        setId(null);
        setOpenDelDialog(false);
    };
  
    const handleDelete = async (id) => {
        // await axios.delete(`${process.env.REACT_APP_API_URL}/api/dashboard/support/${id}`, {
        //     headers: {
        //         Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        //     }
        // });

        // // update states
        // const support = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/support`, {
        //     headers: {
        //       Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        //     }
        // });
        // let number = 0;
        // setTicketData(support.data.result.map((v) => {
        //     number+=1;
        //     return { ...v, no: number };
        // }));
        
        // handleCloseDeleteDialog();
    };

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const handleClickAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    useEffect(() => {
        const getAds = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/adsmitra`, {
              headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
              }
            });
            let number = 0;
            setAdsData(res.data.result.map((v) => {
              number+=1;
              return { ...v, no: number };
            }));
          } catch (err) {
            console.log(err);
          }
        };
        getAds();
    }, [])

    return (
        <div style={{ minHeight: '80vh', padding: '0px 11px'}}>
            <Snackbar
                open={openAlert}
                autoHideDuration={2500}
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top' + 'center'}
            >
                <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                <Formik
                    initialValues={{ nama: null, whatsapp: null, targetkota: null, program: null }}
                    validate={values => {
                        const errors = {};
                        if (!values.nama) {
                            errors.nama = 'Wajib diisi';
                        }
                        if (!values.whatsapp) {
                            errors.whatsapp = 'Wajib diisi';
                        }
                        if (!values.targetkota) {
                            errors.targetkota = 'Wajib diisi';
                        }
                        if (!values.program) {
                            errors.program = 'Wajib diisi';
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        try {
                            await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/adsmitra`, values, {
                                headers: {
                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            // update states
                            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/adsmitra`, {
                                headers: {
                                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                }
                            });
                            let number = 0;
                            setAdsData(res.data.result.map((v) => {
                                number+=1;
                                return { ...v, no: number };
                            }));
                            setAlertStatus('success');
                            setAlertMessage('Tambah adsense berhasil');
                            setOpenAlert(true);
                            handleClose();
                        } catch (err) {
                            console.log(err);
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                    }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                    TAMBAH ADSENSE
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    required
                                    fullWidth
                                    label="Nama"
                                    onChange={handleChange}
                                    name="nama"
                                />
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.nama && touched.nama && errors.nama}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    required
                                    fullWidth
                                    label="Whatsapp"
                                    onChange={handleChange}
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                    name="whatsapp"
                                />
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.whatsapp && touched.whatsapp && errors.whatsapp}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    required
                                    fullWidth
                                    label="Target Kota"
                                    onChange={handleChange}
                                    name="targetkota"
                                />
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.targetkota && touched.targetkota && errors.targetkota}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Program</InputLabel>
                                    <Select
                                        fullWidth
                                        required
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Program"
                                        onChange={handleChange}
                                        name="program"
                                    >
                                        <MenuItem value="1 Pekan 7x50rb @Rp. 350.000,-">1 Pekan 7x50rb @Rp. 350.000,-</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                    {errors.program && touched.program && errors.program}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                            </Grid>
                        </Grid>
                    </form>
                    )}
                </Formik>
                </Box>
            </Modal>
            <Grid container>
                <Grid item xs={12} my={2}>
                    <Typography variant="h5" fontWeight="700">Adsense Mitra</Typography>
                </Grid>
            </Grid>
            <Stack direction="row" spacing={2} sx={{ py: '20px' }}>
                <Button variant="contained" startIcon={<AddCircleIcon />} onClick={handleOpen}>
                  Ads baru
                </Button>
            </Stack>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '66vh', sm: 640, md: 768} }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                    <TableHead>
                    <TableRow>
                        <TableCell align="left">No</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Tanggal</TableCell>
                        <TableCell align="left">Program Ads</TableCell>
                        <TableCell align="left">Target Kota</TableCell>
                        <TableCell align="left">Nama</TableCell>
                        <TableCell align="left">Whatsapp</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {adsData.map((row) => (
                        <TableRow
                            key={row.idmitraagen}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="left">{row.no}</TableCell>
                            <TableCell align="left">{row.status}</TableCell>
                            <TableCell align="left">{row.tgl}</TableCell>
                            <TableCell align="right">{row.program}</TableCell>
                            <TableCell align="left">{row.targetkota}</TableCell>
                            <TableCell align="left">{row.nama}</TableCell>
                            <TableCell align="left">{row.whatsapp}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" component="div" paddingTop={2} paddingX={2}>
                        Program Ads Rekrut Tim Mitra   
                    </Typography> 
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" component="p" padding={2}>
                        Biaya 50rb/hari kali 7 hari jadi 350rb. <br/>
                        Setting Ads seluruhnya dikelola pusat. <br/>
                        Setting konversi ke nomor WA. <br/>
                        DB tinggal terima WA saja dari calon mitra. <br/>
                        Ads pakai landingpage, fanspage dan IG pusat. <br/>
                        Lokasi target sesuai pulau DB bersangkutan. <br/>
                    </Typography>
                    <Typography variant="subtitle2" component="p" padding={2}>
                        Persiapan DB hanya nomor WA aktif dan eksekusi trafik yang masuk ke WA supaya bisa closing jadi mitra agen, reseller atau marketer
                        karena mayoritas yang klik adalah cold market jadi perlu edukasi dari basic hingga memahami value produk wanoja.
                        nanti dikasih copywriting standar untuk menjawab calon mitra, bisa disesuaikan dengan kebutuhan masing2.
                    </Typography>
                    <Typography variant="subtitle2" component="p" paddingX={2} paddingTop={2}>
                        Program ads kami hanya menggiring calon konsumen untuk masuk ke kontak DB, adapun hasil/closing tergantung eksekusi DB masing2.
                        Jika berminat silahkan isi
                    </Typography>
                    <Typography variant="subtitle2" component="p" padding={2}>
                        nama: <br/>
                        asal kota : <br/>
                        nomor WA aktif : <br/>
                    </Typography>
                    <Typography variant="subtitle2" component="p" paddingX={2} paddingTop={2}>
                        Transfer ke rekening 109458746014 <br/>
                        a.n. Asep Wahyu Shopiyudin <br/>
                        Bank JAGO (kode bank 542). <br/>
                        Rp.350.000,- <br/>
                    </Typography>
                    <Typography variant="subtitle2" component="p" padding={2}>
                        Tahapannya: <br/>
                        <ol>
                            <li>Waiting List</li>
                            <li>Payment</li>
                            <li>Running</li>
                        </ol>
                    </Typography>
                    <Typography variant="subtitle2" component="p" padding={2}>
                        Ads segera kami running setelah payment. tiap awal pekan, bisa hari senin atau selasa karena ads perlu riset dulu untuk dapat audience yang tepat dan efektif.
                        <br/>
                        <br/>
                        Barakallahufikunna.<br/>
                        Wanoja ITSupport
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}

export default Adsmitra
